<template>
<div class="right_body action_body"
  v-loading="isLoading"
  :element-loading-background="loadingBg"
  :element-loading-text="loadingTxt"
  >
		<span class="btn right_sub_btn save_btn" @click.stop="subSave">提交数据</span>
     	<div class="active_rumb"><span class="txt">创建BOM</span></div>

		<div class="coll header_box">
			<h2 class="title"><span>抬头信息</span></h2>
			<v-head
			:fromData="fromData" 
			:noFromData="noFromData"
			:customerList="this.$store.state.cache.customerList"
      		:factoryList="this.$store.state.cache.factoryList"
			:targetUnitList="this.$store.state.cache.unitList"
			></v-head>
		</div>

		<div class="coll list_content">
			<h2 class="title"><span>数据明细</span></h2>
			<v-list
			:fromData="fromData"
      		:noFromData="noFromData"
			ref="listChild"
			></v-list>
		</div>
	</div>
</template>

<script>
import {bomApi,factoryApi} from 'api/base.js';
import {queryOrder,targetUnit} from 'api/business.js'

import vHead from './components/bomNew/head.vue';
import vList from './components/bomNew/list.vue';

import { mapState,mapActions } from 'vuex';
export default {
	components:{
		vHead,
		vList
	},
  	data() { 
      return {
		textarea: '',
        isLoading:true,
        loadingBg:"rgba(255,255,255,1)",
        loadingTxt:"加载中",
        id:'',
        isChildComponent:false,
        //需要提交的数据
        fromData:{
		  fromBatch:1,
		  toBatch:999999999,
          bomComponent:[]
        },
        //不需要提交的数据
        noFromData:{}
      };
  },
	//设置校验规则
	vuerify:{
		'fromData.voucherDate':[
			'required',//必填项
			/* {
				test (val) {
					return /\d{4}-\d{1,2}-\d{1,2}/.test(val) && Date.parse(val)
				},
				message: '日期格式不正确 yyyy-mm-dd'
			}, */
		]
	},
	computed: {
		errors () {
		  return this.$vuerify.$errors
		}
	},
	watch:{
		fromData:function(val,old){
			console.log(val,old);
		}
	},
	created(){
		//请求初始数据
		this.id = this.$route.params.id;
		this.getInit();
		this.getStartData();
	},
  methods: {
	  //获取初始数据
	  async getInit(){
      let id = this.$route.params.id;
      //获取当前数据
      if(id){//修改编辑
		let detail = await this.$get(bomApi.find,{'bomBillId':this.id});
		console.log(detail)
        if(detail.status){
          this.isEdit = true;
		  this.fromData = detail.data;
		
			this.$store.state.cache.selectedMatterBom = detail.data.bomComponent;
			
			// this.$store.state.cache.selectedMatterBom.forEach((item,index)=>{
			// 	item.bomComponentDesc = detail.data.bomComponent(index).materialDesc
			// })
			// this.fromData.postingDate = detail.data.createDate;
			//  this.fromData.saleVoucherNo = detail.data.bomComponent.saleVoucherNo
        }
      }
	  },
    ...mapActions('cache',['clearCache']),
    handleClick(tab, event) {
    },
  //关闭弹窗
  handleClose(){
  },
  //需要请求的初始数据
  async getStartData(){
    //console.log(this.$store.state.cache.customerList,'==444==');
		//工厂列表
		if(!this.$store.state.cache.factoryList){
      	let factoryList = await this.$post(factoryApi.list,this.$store.state.getAllPage);
		  if(factoryList.status){
		    factoryList.data.list.forEach((item)=>{
		      item.value = item.factoryCode+'-' + item.factoryDesc;
		    });
        this.$store.state.cache.factoryList = factoryList.data.list;
        console.log(this.$store.state.cache.factoryList,"====------====")
		  }else{
		    this.$store.state.cache.factoryList = null;
		  }
	}


	//计量单位
		if(!this.$store.state.cache.unitList){
      let unitList = await this.$post(targetUnit.list,this.$store.state.getAllPage);
      console.log(unitList,'==========')
		  if(unitList.status){
		    unitList.data.list.forEach((item)=>{
		      item.value = item.unitCode+'-' + item.unitDesc;
		    });
        this.$store.state.cache.unitList = unitList.data.list;
        // console.log(this.$store.state.cache.unitList,"====------====")
		  }else{
		    this.$store.state.cache.unitList = null;
		  }
    }
    this.isLoading = false;
	},

	//保存提交数据
	async subSave(){
		console.log(this.fromData,"======== 测试表头数据 ========")
        let vm = this;
		if(!this.fromData.materialCode){ 
			this.$message.error('请选择物料编码');
			return false;
		} 
		if(!this.fromData.factoryId){
			this.$message.error('请选择工厂');
			return false;
		}
		if(!this.fromData.basicNum){
			this.$message.error('请选择基本数量');
			return false;
		}
		if(!this.fromData.bomBasicUnitName){
			this.$message.error('请选择计量单位');
			return false;
		}
		if(!this.fromData.bomStatus){
			this.$message.error('请选择BOM状态');
			return false;
		}
		
	
	let id = this.$route.params.id;
      var postUrl = bomApi.add;
	  if(id) postUrl = bomApi.edit;
	  
	this.fromData.bomComponent = this.$store.state.cache.selectedMatterBom;

    this.fromData.startDate = this.$moment(this.fromData.startDate).format("YYYY-MM-DD");
	
	console.log(this.fromData)
	// if(this.fromData.materialCode == this.fromData.bomComponent[0].materialCode){
	// 	alert(0)
	// 	return false;
	// }
	let isTrue = true;
		this.fromData.bomComponent.forEach((item) => {
			if(!item.componentNum){
				vm.$message.error('请输入数量');
				isTrue = false;
				return false;
			}
		});
	if(!isTrue) return false;
    this.isLoading = true;
    this.loadingBg = "rgba(255,255,255,0.5)";
    this.loadingTxt = "数据处理中...";
	let res = await this.$post(postUrl,this.fromData);
	let json=JSON.stringify(this.fromData)
	console.log(json)
	this.isLoading = false;
	console.log(res)
    if(res.status){
		console.log(res) 
        let successMsg = id ? "物料 "+res.data.materialCode + " 修改成功。是否继续修改新的销售订单？" : "物料 "+res.data.materialCode + " 的BOM " +res.data.bomComponent[0].bomBillNo +" 创建成功，是否继续创建新的物料清单？";
      this.$confirm(successMsg, '提示', {
        confirmButtonText: '继续',
        cancelButtonText: '退出',
        type: 'success'
      }).then(() => {
        //凭证和过账默认今天
        let nowData = new Date();
        this.fromData = {
          'voucherDate':nowData,
          'postingDate':nowData,
          "bomComponent":[]
        };
		this.noFromData = {};
		vm.$store.state.cache.selectedMatterBom = [];
        //清除部分缓存数据
        vm.clearCache();
      }).catch(() => {
		 //凭证和过账默认今天
        let nowData = new Date();
        this.fromData = {
          'voucherDate':nowData,
          'postingDate':nowData,
          "bomComponent":[]
        };
		this.noFromData = {};
        vm.$router.push({name:'home'});
        //清除部分缓存数据
        vm.clearCache();
      });
    }else{
      this.$message.error(res.errorMsg);
    }
	 }
	},
}
</script>

<style lang="stylus" scoped>

</style>
